<main>
    <div class="card">
        <form>
            <h1>Editar Permissão</h1>
            <label id="label-input" for="name">
                <span>Nome:</span>
                <input [(ngModel)]="permissao.vc_nome" class="input" type="text" name="permissao.vc_nome" id="name">
            </label>
            <label id="label-input" for="name">
                <span>Descrição:</span>
                <input [(ngModel)]="permissao.vc_descricao" class="input" type="text" name="descricao" id="descricao">
            </label>
            <div id="buttons">
                <button (click)="atualizar()" class="btn-sucesso" type="button">Editar</button>
                <button (click)="cancel()" class="btn-cancelar" type="button">Cancelar</button>
            </div>
        </form>
    </div>
</main>